import React from 'react';
import {
    Card, Typography, Grid, CardContent
} from '@material-ui/core';


const ColorLegend = props => {

    const { dataBuildingOccupancy, counts } = props;

    return (
        <Card style={{ width: '400px' }}>
            <CardContent>
                <Grid container>
                    <Grid container item justifyContent='space-between'>
                        <Typography><strong>Color Legend</strong></Typography>
                        <Typography><strong>Count</strong></Typography>
                    </Grid>


                    <Grid container item justifyContent='space-between'>
                        <div>
                            <div className='legend yellow-legend'/>
                            <Typography variant='body2' display='inline'> Total Delinquent &gt; $1000 </Typography>
                        </div>

                        <Typography variant='body2'>
                            <strong >{counts.total_delinquent}</strong>
                        </Typography>
                    </Grid>

                    <Grid container item justifyContent='space-between'>
                        <div>
                            <div className='legend yellow-legend'/>
                            <Typography variant='body2' display='inline'> Fulls </Typography>
                        </div>

                        <Typography variant='body2'>
                            <strong >{counts.fulls}</strong>
                        </Typography>

                    </Grid>

                    <Grid container item justifyContent='space-between'>
                        <div>
                            <div className='legend purple-legend'/>
                            <Typography variant='body2' display='inline'> Section 8 </Typography>
                        </div>

                        <Typography variant='body2'>
                            <strong >{counts.section_8}</strong>
                        </Typography>

                    </Grid>

                    <Grid container item justifyContent='space-between'>
                        <div>
                            <div className='legend green-legend'/>
                            <Typography variant='body2' display='inline'> NSF </Typography>
                        </div>

                        <Typography variant='body2'>
                            <strong >{counts.nsf}</strong>
                        </Typography>

                    </Grid>

                    <Grid container item justifyContent='space-between'>
                        <div>
                            <div className='legend blue-legend'/>
                            <Typography variant='body2' display='inline'> Adjustment </Typography>
                        </div>

                        <Typography variant='body2'>
                            <strong >{counts.adjustment}</strong>
                        </Typography>

                    </Grid>

                    <Grid container item justifyContent='space-between'>
                        <div>
                            <div className='legend red-legend'/>
                            <Typography variant='body2' display='inline'> Eviction </Typography>
                        </div>

                        <Typography variant='body2'>
                            <strong >{counts.eviction}</strong>
                        </Typography>

                    </Grid>

                    <Grid container item justifyContent='space-between'>
                        <div>
                            <div className='legend grey-legend'/>
                            <Typography variant='body2' display='inline'> Stipulation </Typography>
                        </div>

                        <Typography variant='body2'>
                            <strong >{counts.stipulation}</strong>
                        </Typography>

                    </Grid>

                    <Grid container item justifyContent='space-between'>
                        <div>
                            <div className='legend light-green-legend'/>
                            <Typography variant='body2' display='inline'> Repayment Agreement </Typography>
                        </div>

                        <Typography variant='body2'>
                            <strong >{counts.repayment_agreement}</strong>
                        </Typography>

                    </Grid>

                    <Grid container item justifyContent='space-between'>
                        <div>
                            <div className='legend light-blue-legend'/>
                            <Typography variant='body2' display='inline'> Employee </Typography>
                        </div>

                        <Typography variant='body2'>
                            <strong >{counts.employee}</strong>
                        </Typography>

                    </Grid>

                    <Grid container item justifyContent='space-between'>
                        <div>
                            <div className='legend orange-legend'/>
                            <Typography variant='body2' display='inline'> Govt. Assistance </Typography>
                        </div>

                        <Typography variant='body2'>
                            <strong >{counts.govt_assistance}</strong>
                        </Typography>

                    </Grid>

                    <Grid container item justifyContent='space-between'>
                        <div>
                            <div className='legend cream-legend'/>
                            <Typography variant='body2' display='inline'> Exception </Typography>
                        </div>

                        <Typography variant='body2'>
                            <strong >{counts.exception}</strong>
                        </Typography>

                    </Grid>
                    <Grid item xs={12}>
                        <hr/>
                    </Grid>

                    <Grid container item justifyContent='space-between'>

                        <Typography variant='body2' display='inline'> Occupied Units </Typography>

                        <Typography variant='body2'>
                            <strong >{dataBuildingOccupancy?.occupied_units || dataBuildingOccupancy?.occupied_units_day_1}</strong>
                        </Typography>

                    </Grid>

                    <Grid container item justifyContent='space-between'>

                        <Typography variant='body2' display='inline'> Vacant Units </Typography>

                        <Typography variant='body2'>
                            <strong >{dataBuildingOccupancy?.vacant_units || dataBuildingOccupancy?.vacant_units_day_1}</strong>
                        </Typography>

                    </Grid>


                </Grid>
            </CardContent>
        </Card>
    );
};

export default ColorLegend;
